module.exports = __webpack_public_path__ + "img/Clemence.70fb910d.png";